import getTxpSettings from '../utils/getTxpSettings';
import { mutator } from 'satcheljs';
import { updateTxpSettingFlag } from '../actions/updateTxpSettingFlag';

/**
 * Sets the flag for a specific txp setting type in the store
 */
export default mutator(updateTxpSettingFlag, actionMessage => {
    const txpSettings = getTxpSettings();
    const { flagName } = actionMessage;

    if (flagName == 'CreateEventsFromEmailAsPrivate') {
        txpSettings.CreateEventsFromEmailAsPrivate = actionMessage.enabled;
    } else if (flagName) {
        txpSettings.EntityTypeProcessorLevelSettings[flagName] = actionMessage.value;
    }
});
